import { useMemo } from 'react';
import { FileType } from 'lucide-react';
import { MultipleChoiceFilter } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilter';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { iconSize } from '@duke-hq/ui/constants/scalable';

const MIMETYPE_OPTIONS = [
  { id: 'image', value: 'image', label: 'Images' },
  { id: 'application/pdf', value: 'application/pdf', label: 'PDF' },
  { id: 'application/vnd', value: 'application/vnd', label: 'Documents' },
  { id: 'video', value: 'video', label: 'Videos' },
  { id: 'audio', value: 'audio', label: 'Audio' },
];

export function MimetypeFilter() {
  const { updateFilters, filters } = useFiltersContext();

  const selected = useMemo(() => {
    const mimetype = filters['mimetype'] ?? [];
    const validIds = new Set(MIMETYPE_OPTIONS.map(({ id }) => id));
    return mimetype.filter((id: string) => validIds.has(id));
  }, [filters]);

  return (
    <MultipleChoiceFilter
      items={MIMETYPE_OPTIONS}
      label="Type"
      name="mimetype"
      onFilterChange={({ mimetype }) => updateFilters({ mimetype })}
      onlyUpdateOnChange
      value={selected.join(',')}
      variant="ghost"
      leftIcon={<FileType size={iconSize.md} />}
      rightIcon={undefined}
    />
  );
}
